import { globalStyle, style } from '@vanilla-extract/css';

export const socialContainer = style({
  position: 'relative',
  display: 'flex',
  justifyContent: 'var(--justify-content)',
  borderRadius: 'var(--border-radius)',
  borderWidth: 'var(--border-width)',
  borderColor: 'var(--border-color)',
  borderStyle: 'var(--border-style)',
  gap: 'var(--gap)',

  '@media': {
    'only screen and (--mobile)': {
      justifyContent: 'var(--mobile-justify-content)',
      gap: 'var(--mobile-gap)',
    },
  },
});

globalStyle(`${socialContainer}[data-has-mobile-padding="true"]`, {
  padding: 'var(--padding)',

  '@media': {
    'only screen and (--mobile)': {
      padding: 'var(--mobile-padding, var(--padding))',
    },
  },
});

export const socialIcon = style({
  width: 'var(--icon-size)',
  height: 'var(--icon-size)',
});
